import { CREDENTIAL_URL } from './Constants';

export const getCompanyProfileUrl = (companyId: string) =>
  `companies/${companyId}/profile?multipleAccounts=true`;
export const uploadComapnyAttachemtmentUrl = (
  keyName: string,
  companyId: string
) => `api/upload-attachment?keyName=${keyName}&companyId=${companyId}`;

export const getCompanyStatutoryInformationsUrl = (companyId: string) =>
  `companies/${companyId}/statutory-informations?multipleAccounts=true`;
export const putStatutoryInformationsUrl = (id: string) => `statutory/${id}`;

export const getUIResourcesURL = (userId: string) =>
  `api/resources/ui/user/${userId}`;

export const getRMNewsURL = (category: string) =>
  `rm-news?categories=${category}`;

export const resetPasswordEmail = () => `users/forgot-password`;

export const getCompanyIndentifierUrl = (companyId: string) =>
  `companies-identifier/fetch-identifiers?company_id=${companyId}`;

export const getCompanyIndentifierIdUrl = (gstin: string) =>
  `companies-identifier/search-identifier?docValue=${gstin}`;

export const getSendOTPUrl = () => `api/v1/compliance/gstr-reports/send-otp`;

export const getVerifyOTPUrl = () =>
  `api/v1/compliance/gstr-reports/verify-otp`;

export const getFetchPincodeDetailsUrl = (pincode: string) =>
  `addresses/fetch-state/${pincode}`;

export const getGSTRRepotsUrl = (companyIdentifierId: number) =>
  `compliance/gstr-reports/data-exists?companyIdentifierId=${companyIdentifierId}`;

export const getShowBannerPlatformFeePromptUrl = (companyId: number) =>
  `company/${companyId}/company-account-status`;

export const getShowBannerPromptUrl = (companyId: number) =>
  `api/v1/compliance/gstr-reports/show-prompt?companyId=${companyId}`;
export const deleteCredentialUrl = (gstin: string) =>
  `${CREDENTIAL_URL}/${gstin}`;
export const logoutURL = (user: string) => `api/users/${user}/logout`;
